import React from 'react';
import { withTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import ArrowDown from '@mui/icons-material/KeyboardArrowDownRounded';

class UserDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false
        };
    }

    getUsername = (user) => {
        const name = user?.name;
        const firstName = name?.substring(0, name.indexOf(' '));
        return firstName ? firstName : name;
    };

    matchAuthPages(match, location) {
        if (location.pathname === '/login') {
            return true;
        } else if (location.pathname === '/registration') {
            return true;
        }

        return false;
    }

    render() {
        const { t, user } = this.props;

        return (
            <div className="dropdownContainer">
                {this.props.isUserLoggedIn ? (
                    <div className="userDropdown">
                        <NavLink id="user" className="userLink" to="#">
                            <label>{this.getUsername(user)}</label>
                            <ArrowDown />
                        </NavLink>

                        <div className="submenuDropdown">
                            <a href="/user/profile">{t('NavBar.MyProfile')}</a>

                            <span className="spanLink" onClick={this.props.logout}>
                                {t('NavBar.SignOut')}
                            </span>
                        </div>
                    </div>
                ) : (
                    <NavLink
                        className="rightLink"
                        activeClassName="activeLink"
                        isActive={this.matchAuthPages.bind(this)}
                        to="/login"
                    >
                        {t('NavBar.SignIn')}
                    </NavLink>
                )}
            </div>
        );
    }
}

export default withTranslation(['translation'])(UserDropdown);
